import ticketIcon from '@/assets/img/raffle/ticket.png';
import { pluralizate } from '@/helpers/variables';

export default {
  name: 'raffle-block',
  props: {
    raffle: {
      type: Object,
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      infoOpen: false
    };
  },
  computed: {
    state() {
      if (this.raffle.isMax) return 'max';

      return this.raffle.tickets > 0 ? 'tickets' : 'zero';
    },
    icon() {
      return this.raffle.icon || ticketIcon;
    },
    currency() {
      return this.$t('label.grn');
    },
    step() {
      return this.money(this.raffle.step);
    },
    ticketsLabel() {
      return this.ticketsCount(this.raffle.tickets);
    },
    maxLabel() {
      return this.ticketsCount(this.raffle.maxTickets);
    },
    left() {
      return this.money(this.raffle.leftToNext);
    },
    from() {
      const { tickets, step, amount } = this.raffle;

      return this.money(tickets > 0 ? tickets * step : amount);
    },
    to() {
      const { tickets, step } = this.raffle;

      return this.money((tickets + 1) * step);
    },
    progress() {
      const { step, leftToNext } = this.raffle;
      if (!step || leftToNext == null) return 0;

      return Math.min(100, Math.max(0, ((step - leftToNext) / step) * 100));
    },
    rules() {
      return [
        this.$t('label.raffle.rule1'),
        this.$t('label.raffle.rule2', { step: this.step }),
        this.$t('label.raffle.rule3', { max: this.maxLabel }),
        this.$t('label.raffle.rule4'),
        this.$t('label.raffle.rule5')
      ];
    }
  },
  mounted() {
    document.addEventListener('click', this.closeInfo);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeInfo);
  },
  methods: {
    money(value) {
      return Math.round(Number(value) || 0).toLocaleString('uk-UA');
    },
    ticketsCount(count) {
      const word = pluralizate(
        count,
        this.$t('label.raffle.ticketOne'),
        this.$t('label.raffle.ticketSimple'),
        this.$t('label.raffle.ticketMany')
      );

      return `${count} ${word}`;
    },
    closeInfo(event) {
      if (this.$refs.info && !this.$refs.info.contains(event.target)) {
        this.infoOpen = false;
      }
    }
  }
};
